require('../../modules/es.string.anchor');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'anchor');
